/*
 * 老的全局配置文件，待重构，不要在这里添加新的代码
 */

( function( $ ) {

$.extend(window.tower, {
  //delete after refactor to simple-selectText
  selectText: function( input, start, length ) {
    input = $( input );
    if ( !input.is('[type=text], textarea') ) {
      input.focus();
      return;
    }

    if (!$.isNumeric(start) || start < 0) {
      start = input.val().length;
    }

    length = length || start;

    if ( input[0].createTextRange ) {
      var selRange = input[0].createTextRange();
      selRange.collapse( true );
      selRange.moveStart( "character", start );
      selRange.moveEnd( "character", length );
      selRange.select();
    } else if ( input[0].setSelectionRange ) {
      input[0].setSelectionRange( start, start + length );
    }

    input.focus();
  },

  //delete after refactor to simple-highlight
	highlight: function(el, opts) {
		if (el === 'clear') {
			$('.mcw-highlighting').stop(true, true);
			return
		}

		el = $(el);
		opts = $.extend({
			originalColor: el.css('backgroundColor'),
			emphasizeColor: '#FFF6C2'
		}, opts);

		el.stop(true, true)
			.css('backgroundColor', opts.emphasizeColor)
			.addClass('mcw-highlighting')
			.data('opts', opts);

		setTimeout(function() {
			el.animate({
				backgroundColor: opts.originalColor
			}, {
				queue: false,
				duration: 1000,
				always: function() {
					el.css('backgroundColor', '')
						.removeClass('mcw-highlighting')
						.removeData('opts');
				}
			});
		}, 100);
	},

  //delete after refactor to simple-scrollLoad
	scrollLoad: function( page, callback ) {
		var scroller = $(window);

		if ( page === false ) {
			$(window).off('.scrollLoad');
			scroller.off('.scrollLoad');
			return;
		}

		var loadBtn = $(page).find('#btn-load-more');
		if (!loadBtn.length) return;

		var winH = $(window).height();
		$(window).off('.scrollLoad')
			.on('resize.scrollLoad', function(e) {
				winH = $( window ).height();
			});

		scroller.off('.scrollLoad')
			.on('scroll.scrollLoad', function( e ) {
				if (!$(document).find(loadBtn).length || loadBtn.is('.loading, .over')) return;
				checkScroll();
			}).scroll();

		function checkScroll() {
			if ( loadBtn.offset().top - scroller.scrollTop() < winH ) {
				if (!$(document).find(loadBtn).length || loadBtn.hasClass('loading')) return;
				loadBtn.addClass('loading').text( "正在加载更多..." );

				var request = callback( loadBtn );
				if ( request ) {
					request.done( function( result ) {
						result = $.trim(result);

						if ( result ) {
							loadBtn.css('display', 'block').removeClass('loading').text('加载更多内容');
							checkScroll();
						} else {
							loadBtn.removeClass('loading').addClass('over').text('没有更多内容了');
						}
					});
				}
			}
		}
	}
});

})( jQuery );
